module.exports = __webpack_public_path__ + "img/unsex.9b572fa5.svg";